import { InstantInfoValue } from '../../InverterReactQuery';
import { truncateNumber } from '../../../../../../Utils/NumberUtil';

export interface InstantInfoRow {
    key: string;
    name: string;
    valueText: string;
}

const STALE_OR_MISSING_TEXT = '-';

export function buildInstantInfoRows(values: InstantInfoValue[] | undefined): InstantInfoRow[] {
    if (!values) {
        return [];
    }
    return values.map((item, index) => ({
        key: item.teleObjectId != null ? String(item.teleObjectId) : `${item.name ?? 'row'}-${index}`,
        name: item.name ?? '-',
        valueText: formatInstantInfoValue(item),
    }));
}

export interface InstantInfoValueParts {
    value: string;
    unit: string;
}

export function formatInstantInfoValueParts(item: InstantInfoValue): InstantInfoValueParts {
    const unit = item.unityName ?? '';
    if (item.value === null || item.value === undefined || Number.isNaN(Number(item.value))) {
        return { value: STALE_OR_MISSING_TEXT, unit };
    }
    return { value: `${truncateNumber(item.value, 2)}`, unit };
}

export function formatInstantInfoValue(item: InstantInfoValue): string {
    const { value, unit } = formatInstantInfoValueParts(item);
    return unit ? `${value} ${unit}` : value;
}
